<div class="row no-gutters">
  <div class="col-12 col-sm-5 border-right">
    <div class="h-50">
      <app-month-rent [rent]="nextMonthRent"></app-month-rent>
    </div>
    <div class="h-50 border-top">
      <app-contract-duration [data]="averageContractAge"></app-contract-duration>
    </div>
  </div>
  <div class="col-12 col-sm-7">
    <app-vacancies [data]="model"></app-vacancies>
  </div>
</div>
